import { DEPOSIT_METHOD, WITHDRAW_METHOD, PROMOTION_SLUG_BY_TYPE, INSTRUCTION_SLUGS } from '~/constants'
import { AccountTabs } from '~/constants/account'
import { LOBBY_GAME_URLS } from '~/configs/page-url'
import type { NavigationItem, PageInfo } from '~/utils/interface'

const globImages: GlobImageI = import.meta.glob('~/assets/images/icons/*', {
  eager: true
})
const iconImgUrl = '/assets/images/icons'

export const navigationMenus: NavigationItem[] = [
  {
    label: 'THỂ THAO',
    loginRequired: false,
    link: LOBBY_GAME_URLS.SPORTS,
    isNewTab: false
  },
  {
    label: 'CASINO',
    loginRequired: false,
    link: LOBBY_GAME_URLS.CASINO,
    isNewTab: false,
    iconLabel: getImageURL(globImages, 'icon-label-live', iconImgUrl, 'svg')
  },
  {
    label: 'TRÒ CHƠI',
    loginRequired: false,
    link: LOBBY_GAME_URLS.ALL_GAME,
    isNewTab: false
  },
  {
    label: 'LÔ ĐỀ',
    loginRequired: false,
    link: LOBBY_GAME_URLS.LODE,
    isNewTab: false
  },
  {
    label: 'KHUYẾN MÃI',
    loginRequired: false,
    link: '/khuyen-mai',
    isNewTab: false
  }
]
export const accountMenus: NavigationItem[] = [
  {
    label: 'Tài khoản',
    loginRequired: false,
    isNewTab: false,
    link: AccountTabs.INFORMATION,
    modalId: '',
    modalTab: '',
    icon: getImageURL(globImages, 'ic-account', iconImgUrl, 'svg')
  },
  {
    label: 'Lịch sử giao dịch',
    loginRequired: false,
    isNewTab: false,
    link: AccountTabs.HISTORY_TRANSACTION,
    modalId: '',
    modalTab: '',
    icon: getImageURL(globImages, 'ic-card', iconImgUrl, 'svg')
  },
  {
    label: 'Lịch sử cá cược',
    loginRequired: false,
    isNewTab: false,
    link: AccountTabs.HISTORY_BETTING,
    modalId: '',
    modalTab: '',
    icon: getImageURL(globImages, 'ic-history', iconImgUrl, 'svg')
  },
  {
    label: 'Khuyến mãi',
    loginRequired: false,
    isNewTab: false,
    link: '/khuyen-mai',
    modalId: '',
    modalTab: '',
    icon: getImageURL(globImages, 'ic-promotion', iconImgUrl, 'svg')
  }
]

export const pageInfo: PageInfo[] = [
  {
    name: 'Nạp tiền',
    path: `${AccountTabs.DEPOSIT}&type=${DEPOSIT_METHOD.T_PAY}`,
    instructionLink: `/${INSTRUCTION_SLUGS.HOW_TO_DEPOSIT}?type=${DEPOSIT_METHOD.QR_PAY}`
  },
  {
    name: 'Nạp tiền',
    path: `${AccountTabs.DEPOSIT}&type=${DEPOSIT_METHOD.QR_PAY}`,
    instructionLink: `/${INSTRUCTION_SLUGS.HOW_TO_DEPOSIT}?type=${DEPOSIT_METHOD.QR_PAY}`
  },
  {
    name: 'Nạp tiền',
    path: `${AccountTabs.DEPOSIT}&type=${DEPOSIT_METHOD.IBANKING}`,
    instructionLink: `/${INSTRUCTION_SLUGS.HOW_TO_DEPOSIT}?type=${DEPOSIT_METHOD.IBANKING}`
  },
  {
    name: 'Nạp Tiền',
    path: `${AccountTabs.DEPOSIT}&type=${DEPOSIT_METHOD.PHONE_CARD}`,
    instructionLink: `/${INSTRUCTION_SLUGS.HOW_TO_DEPOSIT}?type=${DEPOSIT_METHOD.PHONE_CARD}`
  },
  {
    name: 'Nạp Tiền',
    path: `${AccountTabs.DEPOSIT}&type=${DEPOSIT_METHOD.MOMO}`,
    instructionLink: `/${INSTRUCTION_SLUGS.HOW_TO_DEPOSIT}?type=${DEPOSIT_METHOD.MOMO}`
  },
  {
    name: 'Nạp Tiền',
    path: `${AccountTabs.DEPOSIT}&type=${DEPOSIT_METHOD.CRYPTO}`,
    instructionLink: `/${INSTRUCTION_SLUGS.HOW_TO_DEPOSIT}?type=${DEPOSIT_METHOD.CRYPTO}`
  },
  {
    name: 'Rút Tiền',
    path: `${AccountTabs.WITHDRAW}&type=${WITHDRAW_METHOD.IBANKING}`,
    instructionLink: `/${INSTRUCTION_SLUGS.HOW_TO_WITHDRAW}?type=${WITHDRAW_METHOD.IBANKING}`
  },
  {
    name: 'Rút Tiền',
    path: `${AccountTabs.WITHDRAW}&type=${WITHDRAW_METHOD.PHONE_CARD}`,
    instructionLink: `/${INSTRUCTION_SLUGS.HOW_TO_WITHDRAW}?type=${WITHDRAW_METHOD.PHONE_CARD}`
  },
  {
    name: 'Rút Tiền',
    path: `${AccountTabs.WITHDRAW}&type=${WITHDRAW_METHOD.CRYPTO}`,
    instructionLink: `/${INSTRUCTION_SLUGS.HOW_TO_WITHDRAW}?type=${WITHDRAW_METHOD.CRYPTO}`
  },
  {
    name: 'Lịch Sử',
    path: AccountTabs.HISTORY_TRANSACTION
  },
  {
    name: 'Lịch Sử',
    path: AccountTabs.HISTORY_BETTING
  },
  { name: 'Thông Tin Cá Nhân', path: AccountTabs.INFORMATION },
  { name: 'Thông Tin Cá Nhân', path: AccountTabs.CHANGE_PASSWORD },
  { name: 'Thông Tin Cá Nhân', path: AccountTabs.REFUND },
  { name: 'Thông Tin Cá Nhân', path: AccountTabs.USER_BANK },
  {
    name: 'Chuyển ví',
    path: `${AccountTabs.TRANSFER_MONEY}`,
    instructionLink: `/${INSTRUCTION_SLUGS.HOW_TO_TRANSFER}`
  },
  { name: 'Giao dịch coin12', path: AccountTabs.COIN12 }
]
export const headerPromotion = [
  { name: 'ĐUA TOP TÀI PHÚ - NHẬN QUÀ TIỀN TỈ', path: PROMOTION_SLUG_BY_TYPE.DUA_TOP_THE_THAO },
  { name: 'Tặng 100k khi cược tại Bongk', path: PROMOTION_SLUG_BY_TYPE.NEW_AGENCY },
  { name: 'Khuyến Mãi Hoàn Trả 1.5%', path: PROMOTION_SLUG_BY_TYPE.COMMISSION },
  { name: 'Thưởng 100% tiền nạp lần đầu', path: PROMOTION_SLUG_BY_TYPE.WELCOME },
  { name: 'Thưởng 50% tiền nạp lần 2', path: PROMOTION_SLUG_BY_TYPE.FIRST_50 }
]
